((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MoveCalmlyHeaderRuntimeState = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  function bindCart({ root, currentRoot, currentController, createController }) {
    if (currentController && currentRoot === root) return { root: currentRoot, controller: currentController };
    currentController?.destroy?.();
    return { root, controller: root ? createController(root) : null };
  }

  function teardown({ scope, activeDialog, closeDialog, cartController, body }) {
    cartController?.destroy?.();
    if (activeDialog) closeDialog(activeDialog, false);
    scope?.querySelectorAll('.mc-dialog').forEach((dialog) => {
      dialog.dataset.open = 'false';
      dialog.setAttribute('aria-hidden', 'true');
    });
    body?.classList.remove('mc-scroll-lock');
    return { cartController: null, cartRoot: null, returnFocus: null };
  }

  return Object.freeze({ bindCart, teardown });
});
